import { msg } from '../messages'
import * as Util from '../util'

export function match(regex: RegExp) {
  return (value: string) => {
    if (!Util.isEmpty(value) && !regex.test(value)) {
      return msg('match', value, regex)
    }
  }
}
